import { render, staticRenderFns } from "./socialMenu.vue?vue&type=template&id=467c9491&scoped=true&"
import script from "./socialMenu.vue?vue&type=script&lang=js&"
export * from "./socialMenu.vue?vue&type=script&lang=js&"
import style0 from "./socialMenu.vue?vue&type=style&index=0&id=467c9491&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467c9491",
  null
  
)

component.options.__file = "socialMenu.vue"
export default component.exports